import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'formatWithOrdinalIndicator',
})
export class FormatWithOrdinalIndicatorPipe implements PipeTransform {
  transform(value: string, locale = 'en'): string {
    const date: Date = new Date(value);

    const day: number = date.getDate();
    const month: string = date.toLocaleString(locale, { month: 'long' });
    let indicator: string;

    if (locale === 'fr') {
      indicator = this.getFrenchOrdinalIndicator(day);
    } else {
      indicator = this.getEnglishOrdinalIndicator(day);
    }

    return `${day}${indicator} ${month}`;
  }

  getFrenchOrdinalIndicator(day: number): string {
    return day === 1 ? 'er' : '';
  }

  getEnglishOrdinalIndicator(day: number): string {
    if (day === 1 || day === 21 || day === 31) {
      return 'st';
    } else if (day === 2 || day === 22) {
      return 'nd';
    } else if (day === 3 || day === 23) {
      return 'rd';
    }
    return 'th';
  }
}
